export default "__VITE_ASSET__47e0f07f__"